import axios from "axios";
import {
  SET_BREADCRUMB,
  SET_BREADCRUMB_SEARCH,
} from "../_constants";

export const setBreadcrumb = (breadcrumb) => {
  return { type: SET_BREADCRUMB, payload: breadcrumb };
};

export const setBreadcrumbSearch = (breadcrumbSearch) => {
  return { type: SET_BREADCRUMB_SEARCH, payload: breadcrumbSearch };
};

